function render( inventoryLocation: any ) {
	if ( inventoryLocation.parent?.name ) {
		return `${inventoryLocation.parent.name} - ${inventoryLocation.name}`
	}
	return inventoryLocation.name
}

export default {
	field: 'inventoryLocation',
	name: 'Store',
	width: '260px',
	render,
}
